export default "__VITE_ASSET__KdXQPvKm__"